<div class="shipments-page" [ngClass]="{ 'mobile-optimized': isMobileView }">

  <div class="shipments-toolbar">
    <div class="shipments-toolbar__copy">
      <p class="shipments-kicker">Fulfillment</p>
      <h2 class="shipments-title">My Shipments</h2>
    </div>

    <mat-form-field
      class="shipments-room-field"
      appearance="outline"
      *ngIf="webinarRooms.length != 1">
      <mat-label>Webinar room</mat-label>
      <mat-select
        placeholder="Select webinar room"
        (selectionChange)="GetStatsOfRoom($event)"
        [formControl]="webinarRoomControl">
        <mat-option *ngFor="let webinarRoom of webinarRooms" [value]="webinarRoom.webinarRoomId">
          {{ webinarRoom.roomName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="shipments-search">
    <mat-form-field class="shipments-search-field" appearance="outline">
      <mat-label>Find a winner</mat-label>
      <input
        matInput
        placeholder="Search webinar, winner, or email"
        [(ngModel)]="searchQuery"
        (input)="filterWebinars()" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <div class="stats-row">
    <div class="stat-card stat-card--pending">
      <span class="stat-card__icon" aria-hidden="true">
        <mat-icon>inventory_2</mat-icon>
      </span>
      <div class="stat-card__content">
        <span class="stat-card__label">Awaiting ship</span>
        <span class="stat-card__value">{{ NonShippedWebinarsFiltered.length }}</span>
        <span class="stat-card__meta" *ngIf="NonShippedWebinarsFiltered.length">
          Avg. {{ GetAveraging() }} days since the draw
        </span>
        <span class="stat-card__meta" *ngIf="!NonShippedWebinarsFiltered.length">
          Queue is clear
        </span>
      </div>
    </div>
    <div class="stat-card stat-card--shipped">
      <span class="stat-card__icon" aria-hidden="true">
        <mat-icon>rocket_launch</mat-icon>
      </span>
      <div class="stat-card__content">
        <span class="stat-card__label">On the way</span>
        <span class="stat-card__value">{{ ShippedWebinarsFiltered.length }}</span>
        <span class="stat-card__meta">Winners notified</span>
      </div>
    </div>
  </div>

  <ng-template #carrierMark let-row>
    <span class="carrier-mark" [ngClass]="'carrier-mark--' + carrierKind(row)" [attr.title]="carrierLabel(row)">
      <svg *ngIf="carrierKind(row) === 'usps'" viewBox="0 0 56 36" aria-hidden="true">
        <rect width="56" height="36" rx="6" fill="#2C2A70"/>
        <rect y="27" width="56" height="9" fill="#E31937"/>
        <path d="M12 10.5c3.2-2.4 8.2-3 12.4-.4 1.6 1 2.6 2.4 3.6 2.4s2-.8 3.2-1.8c2.6-2 6.6-2.6 9.8-.4L39 13.2c-2.4-1.4-5.2-1-7 .4-1.6 1.2-2.8 2.4-4.8 2.4s-3.4-1.4-5-2.4c-2.2-1.4-5.6-1.6-8 .2L12 10.5z" fill="#fff"/>
        <text x="28" y="24" text-anchor="middle" fill="#fff" font-size="9.5" font-weight="800" font-family="Arial, sans-serif">USPS</text>
      </svg>
      <svg *ngIf="carrierKind(row) === 'ups'" viewBox="0 0 36 40" aria-hidden="true">
        <path d="M18 2.2 33 8.4v13.2c0 8.4-8.2 14.6-15 16.2-6.8-1.6-15-7.8-15-16.2V8.4L18 2.2z" fill="#351C15"/>
        <text x="18" y="24" text-anchor="middle" fill="#FFB500" font-size="11" font-weight="800" font-family="Arial, sans-serif">UPS</text>
      </svg>
      <svg *ngIf="carrierKind(row) === 'fedex'" viewBox="0 0 72 28" aria-hidden="true">
        <rect width="72" height="28" rx="5" fill="#fff"/>
        <text x="5" y="20" fill="#4D148C" font-size="15" font-weight="800" font-family="Arial, sans-serif">Fed</text>
        <text x="37" y="20" fill="#FF6600" font-size="15" font-weight="800" font-family="Arial, sans-serif">Ex</text>
      </svg>
      <svg *ngIf="carrierKind(row) === 'dhl'" viewBox="0 0 64 28" aria-hidden="true">
        <rect width="64" height="28" rx="5" fill="#FFCC00"/>
        <text x="32" y="19" text-anchor="middle" fill="#D40511" font-size="14" font-weight="800" font-family="Arial, sans-serif">DHL</text>
      </svg>
      <svg *ngIf="carrierKind(row) === 'other'" viewBox="0 0 36 36" aria-hidden="true">
        <rect width="36" height="36" rx="9" fill="#069494"/>
        <path d="M6 22h3.2l3.4-8.2H24v3.2h3.4L30 22h2v3.2h-2.2a3.2 3.2 0 0 1-6.2 0h-7.2a3.2 3.2 0 0 1-6.2 0H6V22zm6.4 3.2a1.6 1.6 0 1 0-3.2 0 1.6 1.6 0 0 0 3.2 0zm14.8 0a1.6 1.6 0 1 0-3.2 0 1.6 1.6 0 0 0 3.2 0zM14.2 16.2 12 22h15.2v-5.8H14.2z" fill="#fff8e7"/>
      </svg>
    </span>
  </ng-template>

  <mat-tab-group class="shipments-tabs" [(selectedIndex)]="activeTabIndex" animationDuration="200ms">

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">pending_actions</mat-icon>
        Pending
        <span class="tab-badge tab-badge--pending" *ngIf="NonShippedWebinarsFiltered.length">
          {{ NonShippedWebinarsFiltered.length }}
        </span>
      </ng-template>

      <div class="tab-content">
        <div class="empty-state" *ngIf="!pendingDateGroups.length">
          <mat-icon>verified</mat-icon>
          <h3>All caught up</h3>
          <p>No pending shipments right now. New winners will land here after their webinar ends.</p>
        </div>

        <mat-accordion class="date-accordion" multi *ngIf="pendingDateGroups.length">
          <mat-expansion-panel
            *ngFor="let group of pendingDateGroups"
            class="date-panel date-panel--pending"
            [expanded]="isPanelExpanded(getDatePanelId(group.dateKey))"
            (opened)="onPanelOpened(getDatePanelId(group.dateKey))"
            (closed)="onPanelClosed(getDatePanelId(group.dateKey))">
            <mat-expansion-panel-header collapsedHeight="68px" expandedHeight="68px">
              <div class="date-header">
                <span class="date-header__icon" aria-hidden="true">
                  <mat-icon>event</mat-icon>
                </span>
                <div class="date-header__copy">
                  <span class="date-header__kicker">Draw day</span>
                  <span class="date-header__title">{{ group.dateLabel }}</span>
                </div>
                <div class="date-header__meta">
                  <span class="date-header__count">{{ group.items.length }}</span>
                  <span class="date-header__count-label">to ship</span>
                </div>
              </div>
            </mat-expansion-panel-header>

            <div class="cards-grid">
              <article
                class="shipment-tile shipment-tile--pending"
                *ngFor="let row of group.items"
                [attr.id]="'shipment-' + row.id">
                <div class="tile-band">
                  <div class="tile-band__copy">
                    <span class="tile-kicker">Prize to pack</span>
                    <h3 class="tile-name">{{ row.webinar }}</h3>
                    <span class="tile-ended">Ended {{ row.webinarEndDate | date:'mediumDate' }}</span>
                  </div>
                  <span class="days-badge" [ngClass]="getDaysUrgencyClass(row.daysPassed)">
                    {{ row.daysPassed }}d
                  </span>
                </div>

                <div class="tile-body">
                  <div class="party">
                    <div class="party__row">
                      <span class="party__label">Winner</span>
                      <span class="party__value">{{ row.newOwner }}</span>
                      <span class="party__sub">{{ row.newOwnerEmail }}</span>
                    </div>
                    <div class="party__row" [class.party__row--error]="!row.shipmentAddress">
                      <span class="party__label">Ship to</span>
                      <ng-container *ngIf="row.shipmentAddress; else missingPendingAddress">
                        <span class="party__value">{{ row.shipmentAddress.street }}</span>
                        <span class="party__sub">
                          {{ row.shipmentAddress.city }}{{ row.shipmentAddress.state?.name ? ', ' + row.shipmentAddress.state.name : '' }}
                          {{ row.shipmentAddress.zipCode }}
                        </span>
                        <span class="party__sub" *ngIf="row.shipmentAddress.phone">{{ row.shipmentAddress.phone }}</span>
                      </ng-container>
                      <ng-template #missingPendingAddress>
                        <span class="party__value party__value--error">No address on file</span>
                      </ng-template>
                    </div>
                  </div>

                  <div class="ship-facts" *ngIf="showShippingDetails(row) || isUspsLabelActive(row)">
                    <div class="ship-facts__carrier">
                      <ng-container *ngTemplateOutlet="carrierMark; context: { $implicit: row }"></ng-container>
                      <div class="ship-facts__carrier-copy">
                        <span class="ship-facts__name">{{ carrierLabel(row) }}</span>
                        <span class="ship-facts__service" *ngIf="isUspsLabelActive(row)">Label ready</span>
                        <span class="ship-facts__service" *ngIf="row.uspsServiceType">{{ row.uspsServiceType }}</span>
                      </div>
                    </div>
                    <dl class="ship-facts__list">
                      <div class="ship-facts__row" *ngIf="getDisplayTracking(row)">
                        <dt>Tracking</dt>
                        <dd [title]="getDisplayTracking(row)">{{ getDisplayTracking(row) }}</dd>
                      </div>
                      <div class="ship-facts__row" *ngIf="getDisplayShippingPrice(row) != null">
                        <dt>Postage</dt>
                        <dd>{{ getDisplayShippingPrice(row) | currency }}</dd>
                      </div>
                      <div class="ship-facts__row" *ngIf="row.shippedOn">
                        <dt>Shipped</dt>
                        <dd>{{ row.shippedOn | date:'dd MMM yyyy' }}</dd>
                      </div>
                    </dl>
                  </div>

                  <div class="validation-alert" *ngIf="!hasUspsLabel(row) && !isDestinationAddressValid(row)">
                    Address needs a fix before a USPS label can be created.
                  </div>
                </div>

                <div class="tile-actions">
                  <button
                    type="button"
                    class="ship-action ship-action--usps"
                    *ngIf="!hasUspsLabel(row)"
                    (click)="OpenUSPSLabelDialog(row.id)"
                    [disabled]="!isDestinationAddressValid(row)"
                    matTooltip="Create Label"
                    matTooltipShowDelay="0">
                    <span class="ship-action__glyph" aria-hidden="true">
                      <mat-icon>local_post_office</mat-icon>
                    </span>
                    <span class="ship-action__text">Create Label</span>
                  </button>
                  <button
                    type="button"
                    class="ship-action ship-action--download"
                    *ngIf="hasUspsLabel(row) && row.uspsLabelUrl"
                    (click)="downloadLabel(row)"
                    matTooltip="Download Label"
                    matTooltipShowDelay="0">
                    <span class="ship-action__glyph" aria-hidden="true">
                      <mat-icon>download</mat-icon>
                    </span>
                    <span class="ship-action__text">Download Label</span>
                  </button>
                  <button
                    type="button"
                    class="ship-action ship-action--track"
                    (click)="OpenTrackingDialog(row.id)"
                    [matTooltip]="hasManualTracking(row) || getDisplayTracking(row) ? 'Update Tracking' : 'Add Tracking'"
                    matTooltipShowDelay="0">
                    <span class="ship-action__glyph" aria-hidden="true">
                      <mat-icon>alt_route</mat-icon>
                    </span>
                    <span class="ship-action__text">{{ hasManualTracking(row) || getDisplayTracking(row) ? 'Update Tracking' : 'Add Tracking' }}</span>
                  </button>
                  <button
                    type="button"
                    class="ship-action ship-action--notify"
                    *ngIf="isShowNotifyButton(row)"
                    (click)="NotifyUser(getDisplayTracking(row), row.id)"
                    matTooltip="Notify Winner"
                    matTooltipShowDelay="0">
                    <span class="ship-action__glyph" aria-hidden="true">
                      <mat-icon>campaign</mat-icon>
                    </span>
                    <span class="ship-action__text">Notify Winner</span>
                  </button>
                </div>
              </article>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">rocket_launch</mat-icon>
        Shipped
        <span class="tab-badge tab-badge--shipped" *ngIf="ShippedWebinarsFiltered.length">
          {{ ShippedWebinarsFiltered.length }}
        </span>
      </ng-template>

      <div class="tab-content">
        <div class="empty-state" *ngIf="!shippedDateGroups.length">
          <mat-icon>local_shipping</mat-icon>
          <h3>Nothing in transit yet</h3>
          <p>Once you notify winners, completed shipments will stack here.</p>
        </div>

        <mat-accordion class="date-accordion" multi *ngIf="shippedDateGroups.length">
          <mat-expansion-panel
            *ngFor="let group of shippedDateGroups"
            class="date-panel date-panel--shipped"
            [expanded]="isPanelExpanded(getDatePanelId(group.dateKey, true))"
            (opened)="onPanelOpened(getDatePanelId(group.dateKey, true))"
            (closed)="onPanelClosed(getDatePanelId(group.dateKey, true))">
            <mat-expansion-panel-header collapsedHeight="68px" expandedHeight="68px">
              <div class="date-header">
                <span class="date-header__icon" aria-hidden="true">
                  <mat-icon>event_available</mat-icon>
                </span>
                <div class="date-header__copy">
                  <span class="date-header__kicker">Shipped on</span>
                  <span class="date-header__title">{{ group.dateLabel }}</span>
                </div>
                <div class="date-header__meta">
                  <span class="date-header__count">{{ group.items.length }}</span>
                  <span class="date-header__count-label">sent</span>
                </div>
              </div>
            </mat-expansion-panel-header>

            <div class="cards-grid">
              <article
                class="shipment-tile shipment-tile--shipped"
                *ngFor="let row of group.items"
                [attr.id]="'shipment-' + row.id">
                <div class="tile-band">
                  <div class="tile-band__copy">
                    <span class="tile-kicker">Delivered to winner</span>
                    <h3 class="tile-name">{{ row.webinar }}</h3>
                    <span class="tile-ended">Ended {{ row.webinarEndDate | date:'mediumDate' }}</span>
                  </div>
                  <span class="status-badge">Notified</span>
                </div>

                <div class="tile-body">
                  <div class="party">
                    <div class="party__row">
                      <span class="party__label">Winner</span>
                      <span class="party__value">{{ row.newOwner }}</span>
                      <span class="party__sub">{{ row.newOwnerEmail }}</span>
                    </div>
                    <div class="party__row" *ngIf="row.shipmentAddress">
                      <span class="party__label">Shipped to</span>
                      <span class="party__value">{{ row.shipmentAddress.street }}</span>
                      <span class="party__sub">
                        {{ row.shipmentAddress.city }}{{ row.shipmentAddress.state?.name ? ', ' + row.shipmentAddress.state.name : '' }}
                        {{ row.shipmentAddress.zipCode }}
                      </span>
                      <span class="party__sub" *ngIf="row.shipmentAddress.phone">{{ row.shipmentAddress.phone }}</span>
                    </div>
                  </div>

                  <div class="ship-facts">
                    <div class="ship-facts__carrier">
                      <ng-container *ngTemplateOutlet="carrierMark; context: { $implicit: row }"></ng-container>
                      <div class="ship-facts__carrier-copy">
                        <span class="ship-facts__name">{{ carrierLabel(row) }}</span>
                        <span class="ship-facts__service" *ngIf="row.uspsServiceType">{{ row.uspsServiceType }}</span>
                      </div>
                    </div>
                    <dl class="ship-facts__list">
                      <div class="ship-facts__row" *ngIf="getDisplayTracking(row)">
                        <dt>Tracking</dt>
                        <dd [title]="getDisplayTracking(row)">{{ getDisplayTracking(row) }}</dd>
                      </div>
                      <div class="ship-facts__row" *ngIf="getDisplayShippingPrice(row) != null">
                        <dt>Postage</dt>
                        <dd>{{ getDisplayShippingPrice(row) | currency }}</dd>
                      </div>
                      <div class="ship-facts__row" *ngIf="row.shippedOn">
                        <dt>Shipped</dt>
                        <dd>{{ row.shippedOn | date:'dd MMM yyyy' }}</dd>
                      </div>
                    </dl>
                  </div>
                </div>

                <div class="tile-actions">
                  <button
                    type="button"
                    class="ship-action ship-action--download"
                    *ngIf="hasUspsLabel(row) && row.uspsLabelUrl"
                    (click)="downloadLabel(row)"
                    matTooltip="Download Label"
                    matTooltipShowDelay="0">
                    <span class="ship-action__glyph" aria-hidden="true">
                      <mat-icon>download</mat-icon>
                    </span>
                    <span class="ship-action__text">Download Label</span>
                  </button>
                  <button
                    type="button"
                    class="ship-action ship-action--track"
                    (click)="OpenTrackingDialog(row.id)"
                    matTooltip="Update Tracking"
                    matTooltipShowDelay="0">
                    <span class="ship-action__glyph" aria-hidden="true">
                      <mat-icon>alt_route</mat-icon>
                    </span>
                    <span class="ship-action__text">Update Tracking</span>
                  </button>
                  <button
                    type="button"
                    class="ship-action ship-action--notify"
                    *ngIf="isShowNotifyButton(row)"
                    (click)="NotifyUser(getDisplayTracking(row), row.id)"
                    matTooltip="Notify Again"
                    matTooltipShowDelay="0">
                    <span class="ship-action__glyph" aria-hidden="true">
                      <mat-icon>campaign</mat-icon>
                    </span>
                    <span class="ship-action__text">Notify Again</span>
                  </button>
                </div>
              </article>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
